package dev.akshaychordiya.content

/**
 * Something I'm happy to talk about that isn't work.
 *
 * @param emoji Decorative only. The label carries the meaning, so the chip hides the emoji from screen readers rather
 *   than making them announce "car" before "Tesla".
 */
class Interest(val emoji: String, val label: String)

val interests = listOf(
    Interest("🚗", "Tesla"),
    Interest("💻", "Tech"),
    Interest("🏞️", "National parks"),
    Interest("✈️", "Travel"),
)
